export default __webpack_public_path__ + "static/media/centro_andes_2_1.8302bfd2.JPG";